import React from 'react'
import Title from '../layouts/Title'
import { Canva, Docs, Sheets } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    > 
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY WORK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="📝 Task Report (Docs)"
          des="Created and managed detailed content reports using Google Docs. 
          Focused on planning, writing, and documenting daily digital marketing tasks with consistency and clarity."
          src={Docs}
          alt="Google Docs task report by Mukesh Kannan"
          demo="https://docs.google.com/document/d/1tct7Sa7w6HFk-hxSXQfB_EYqlGnyknw9UMaoa1BmChY/edit?usp=sharing"
          // github="#"
        />

        <ProjectsCard
          title="📊 Task Tracker (Sheet)"
          des="Used Google Sheets to organize and monitor marketing activities and performance data. 
          Helped track task progress, maintain schedules, and ensure smooth workflow management."
          src={Sheets}
          alt="Google Sheets task tracker by Mukesh Kannan"
          demo="https://docs.google.com/spreadsheets/d/1lGG0Kg5159q-A_BKPQa0dMV_p31ngZjAeVfAbzD-xk8/edit?usp=sharing"
          // github="#"
        />
        
        <ProjectsCard
          title="🖼️ Banner Design (Canva)"
          des="Designed and created visually engaging banners and social media posts using Canva. 
          Focused on delivering clean, modern layouts tailored for brand consistency and effective digital communication."
          src={Canva}
          alt="Canva Design by Mukesh Kannan"
          demo="https://www.canva.com/design/DAG4xN-mn7E/9E13LUANlYZf5z36A01L9A/view?utm_content=DAG4xN-mn7E&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h228cca2f79"
          // github="#"
        />
      </div>
    </section>
  );
}

export default Projects